<style lang="sass">
@import ~bi/utilities
@import ~bi/brand/variables
@import ../../assets/sass/m3_variables
@import sass/hero
</style>

<template>
    <Zone
        :id="$json.hero.id"
        :dataLabel="$json.hero.dataLabel"
        contrast="light"
        class="g_hero">
        <Logo :baseline="true" />
        <div class="g_mozaique">
            <div
                class="g_image g_image1"
                v-img-src="{ folder: 'mozaique', name: 'image1' }" />
            <div
                class="g_image g_image2"
                v-img-src="{ folder: 'mozaique', name: 'image2' }" />
            <div
                class="g_image g_image3"
                v-img-src="{ folder: 'mozaique', name: 'image3' }" />
        </div>
        <SignaletiquePour />
        <Contact />
    </Zone>
</template>

<script>
import Logo from '../../components/Logo'
import SignaletiquePour from '../../components/SignaletiquePour'
import Contact from '../../components/Contact'

export default {
    name: 'Hero',
    components: {
        Logo,
        SignaletiquePour,
        Contact
    }
}
</script>
